// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__1F6Wy","img":"Card_img__2E8Up","cardText":"Card_cardText__17xRQ","title":"Card_title__3m3ET","dietsPs":"Card_dietsPs__2TXH0","ps":"Card_ps__1OQDu"};